export class ServerError {

    constructor(readonly code: number, readonly message: string) {
    }
}
